import React, { Component } from 'react';
import { Card, Table, Tooltip, Icon, Collapse, Switch, Select, Form } from 'antd';
import { connect } from 'react-redux';
import 'rc-color-picker/assets/index.css';
import './molviewer.css'
import { pdbPdbFileUrl } from '../../UrlManager';



class PDB2AF2panel extends Component {
    handleMoleculeInteraction = (record) => {
        const { viewer } = this.props;
        const chain = record.ch;
       
        viewer.setStyle({}, {cartoon: {color: "grey",opacity: 0.9}});
        viewer.setStyle({chain: chain}, {cartoon: {color: 'orange',opacity: 0.85}});

        viewer.render();
      };
    


    render() {
       
        const { pdbAF2map,searchid } = this.props;
        const columns = [
            {
                title: searchid.toUpperCase() + ' subunit', 
                dataIndex: 'ch',
                key: 'ch', 
                align: 'center'
                // render: () => (<span>{searchid}</span>) // Displaying searchid as fixed value in all rows
            },
            { title: 'Uniprot ID', dataIndex: 'unip_id', key: 'unip_id', align: 'center' },
            {
                title: 'AF2 representative',
                dataIndex: 'rep_id',
                key: 'rep_id',
                align: 'center',
                render: rep_id => rep_id || 'NULL' // Render 'NULL' if rep_id is falsy
            },
            {
                title: 'Check AF2 counterpart',
                dataIndex: 'rep_id',
                key: 'check_af2',
                align: 'center',
                render: (rep_id, record) => { // Accessing the full record to use other fields
                    // Constructing URL; handling missing rep_id by appending 'null'
                    const url = `https://cfold.bme.uic.edu/castpfold/search?${rep_id || 'null'}`;
                    // Displaying dynamic link text based on the row's searchid and unip_id
                    return <a href={url} target="_blank" rel="noopener noreferrer">{searchid} Chain {record.ch}</a>;
                }
            },
        ];

        // Function to render the data for the table
        const renderData = () => {
            if (pdbAF2map && pdbAF2map.fulfilled) {
                return pdbAF2map.value;
            }
            return [];
        };
        const PocsimTip = (
            <p className='tip'> 
                All PDB chains are mapped to their corresponding <a href="https://www.uniprot.org" target="_blank" rel="noopener noreferrer">UniProt</a> entries, which are further mapped to the AF2 representative entries.
            </p>
        );
    
        const pocsimTitle = (
            <span> 
                {' '}
                PDB Counterparts in AF2  
                <Tooltip title={PocsimTip} arrowPointAtCenter={true} placement='right'> 
                {' '}
                    <Icon type="question-circle" /> {' '}
                </Tooltip> {' '}
            </span>
        );
        return (
            <Card title={pocsimTitle}> 
                <Table
                    columns={columns}
                    // expandedRowRender={this.pocketTableRender} // Pass the method to expandedRowRender
                    dataSource={renderData()}
                    pagination={false}
                    onRow={record => ({
                        onClick: () => this.handleMoleculeInteraction(record),
                        onMouseEnter: () => { document.body.style.cursor = 'pointer'; },
                        onMouseLeave: () => { document.body.style.cursor = 'default'; },
                      })}
                />
            </Card>
        );
    }
}

// mapStateToProps connects the Redux state to the props of this component
const mapStateToProps = state => ({
    pdbAF2map: state.repository.pdb2AF2map,
    searchid: state.router.location.search.slice(1),
    viewer: state.viewer.viewer,
});


export default connect(mapStateToProps)(PDB2AF2panel);





// WEBPACK FOOTER //
// ./src/components/searchpage/PDB_AF2.js